export default (state) => {
  state.currentAdministrator.submissionsReport.items = [];
  state.currentAdministrator.submissionsReport.isFetching = true;
  state.currentAdministrator.submissionsReport.totalCount = null;
};
